import {DeviceType, EVENTS, ValueType} from './consts';
import type {DeviceElement, DeviceElementTarget, Device} from '../types';
import {
	DATAPOINT_BUTTON1,
	DATAPOINT_BUTTON2,
	DATAPOINT_BUTTON_COLOR1,
	DATAPOINT_BUTTON_COLOR2,
	DATAPOINT_IS_ONLINE,
	DATAPOINT_LED,
	DATAPOINT_LED_COLOR,
	DATAPOINT_PIN1,
	DATAPOINT_PIN2,
	DATAPOINT_PIN3,
	DATAPOINT_PIN4
} from '../../common/consts';

// Targets #############################################
export const targetButton1Pressed: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.pressed',
	value: 'true',
	name: EVENTS.button1Pressed,
	dataPoint: EVENTS.button1Pressed,
	valueType: ValueType.empty,
	defaultLabel: 'Pressed',
	unit: 'ms',
	availableForCondition: false
};
export const targetButton1Color: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.colorbutton1',
	name: DATAPOINT_BUTTON_COLOR1,
	dataPoint: DATAPOINT_BUTTON1,
	valueType: ValueType.color,
	defaultLabel: 'Button 1 Color',
	value: '#000000',
	unit: '',
	availableForCondition: true
};
export const targetButton2Pressed: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.pressed',
	value: 'true',
	name: EVENTS.button2released,
	dataPoint: EVENTS.button2Pressed,
	valueType: ValueType.empty,
	defaultLabel: 'Pressed',
	unit: 'ms',
	availableForCondition: false
};
export const targetButton2Color: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.colorbutton2',
	name: DATAPOINT_BUTTON_COLOR2,
	dataPoint: DATAPOINT_BUTTON2,
	valueType: ValueType.color,
	defaultLabel: 'Button 2 Color',
	value: '#000000',
	unit: '',
	availableForCondition: true
};
export const targetGpio1: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.gpio1',
	name: DATAPOINT_PIN1,
	dataPoint: DATAPOINT_PIN1,
	valueType: ValueType.outputState,
	defaultLabel: 'GPIO 1',
	value: '',
	unit: 'mHz',
	availableForCondition: true
};
export const targetGpio2: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.gpio2',
	name: DATAPOINT_PIN2,
	dataPoint: DATAPOINT_PIN2,
	valueType: ValueType.outputState,
	defaultLabel: 'GPIO 2',
	value: '',
	unit: 'mHz',
	availableForCondition: true
};
export const targetGpio3: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.gpio3',
	name: DATAPOINT_PIN3,
	dataPoint: DATAPOINT_PIN3,
	valueType: ValueType.outputState,
	defaultLabel: 'GPIO 3',
	value: '',
	unit: 'mHz',
	availableForCondition: true
};
export const targetGpio4: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.gpio4',
	name: DATAPOINT_PIN4,
	dataPoint: DATAPOINT_PIN4,
	valueType: ValueType.outputState,
	defaultLabel: 'GPIO 4',
	value: '',
	unit: 'mHz',
	availableForCondition: true
};
export const targetLightColor: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.ledcolor',
	name: DATAPOINT_LED_COLOR,
	dataPoint: DATAPOINT_LED,
	valueType: ValueType.color,
	defaultLabel: 'LED color',
	value: '#000000',
	unit: '',
	availableForCondition: true
};
export const targetOperatingMode: DeviceElementTarget = {
	labelId: 'rafi.ruleengine.operatingMode',
	name: DATAPOINT_IS_ONLINE,
	dataPoint: DATAPOINT_IS_ONLINE,
	valueType: ValueType.operatingMode,
	defaultLabel: 'Operating Mode',
	value: 'true',
	unit: '',
	availableForCondition: true
};
export const allTargets = [
	targetButton1Color,
	targetButton2Color,
	targetLightColor,
	targetGpio1,
	targetGpio2,
	targetGpio3,
	targetGpio4,
	targetButton1Pressed,
	targetButton2Pressed,
	targetOperatingMode
];
const sBoxButton1Targets = [targetButton1Pressed, targetButton1Color];
const gpioTargets = [targetGpio1, targetGpio2, targetGpio3, targetGpio4];
const sBoxButton2Targets = [targetButton2Pressed, targetButton2Color];
const lightTargets = [targetLightColor];
const operatingModeTargets = [targetOperatingMode];
export const button1Element: DeviceElement = {
	key: 'button1Element',
	dataTargets: sBoxButton1Targets,
	labelId: 'rafi.ruleengine.button1',
	defaultLabel: 'Button 1'
};
export const button2Element: DeviceElement = {
	key: 'button2Element',
	dataTargets: sBoxButton2Targets,
	labelId: 'rafi.ruleengine.button2',
	defaultLabel: 'Button 2'
};
export const lightElement: DeviceElement = {
	key: 'lightElement',
	dataTargets: lightTargets,
	labelId: 'rafi.ruleengine.led1',
	defaultLabel: 'LED'
};
export const statusElement: DeviceElement = {
	key: 'statusElement',
	dataTargets: operatingModeTargets,
	labelId: 'rafi.ruleengine.status.label',
	defaultLabel: 'Status'
};
export const gpioElement: DeviceElement = {
	key: 'gpioElement',
	dataTargets: gpioTargets,
	labelId: 'rafi.ruleengine.gpio',
	defaultLabel: 'GPIO'
};

// DEVICES ###################################################
const deviceSBox: Device = {
	labelId: 'rafi.ruleengine.sbox',
	defaultLabel: 'sBox',
	type: DeviceType.sBox,
	elements: [button1Element, button2Element, gpioElement, statusElement]
};
const deviceSLight: Device = {
	labelId: 'rafi.ruleengine.sLight',
	defaultLabel: 'sLight',
	type: DeviceType.sLight,
	elements: [lightElement, gpioElement, statusElement]
};
const deviceKisIo: Device = {
	labelId: 'rafi.ruleengine.kisIo',
	defaultLabel: 'kisIo',
	type: DeviceType.kisIo,
	elements: [gpioElement, statusElement]
};
export const RuleStructure = {
	devices: [deviceSBox, deviceSLight, deviceKisIo]
};
